import Snackbar from "@mui/material/Snackbar";
import { Button } from "@mui/material";
import "./snackbar.scss";

const SnackBar = ({ open, closeHandler }) => {
  return (
    <Snackbar
      open={open.flag}
      autoHideDuration={2000}
      onClose={closeHandler}
      message={open.text}
      action={
        <Button className="dismiss-btn" size="small" onClick={closeHandler}>
          Dismiss
        </Button>
      }
    ></Snackbar>
  );
};

export default SnackBar;
